import React, { ReactNode } from 'react';
import { DxContainer, DxGrid } from '@dvag/design-system-react';
import { useParams } from 'react-router-dom';

interface CardListContainerProps {
  children: ReactNode;
}

export const CardListContainer = ({ children }: CardListContainerProps) => {
  const { householdId } = useParams();
  const disabledStyle = !householdId
    ? {
        opacity: '0.6',
        pointerEvents: 'none',
      }
    : {};
  return (
    <div style={{ overflow: 'hidden' }} data-testid="card-list">
      <DxContainer color="transparent" style={disabledStyle}>
        <DxContainer color="transparent" className="dashboard-bottom-card-container">
          <DxGrid
            mq1="12/*"
            mq2="12/*"
            mq4="6-6"
            mq5="6-6"
          >
            {children}
          </DxGrid>
        </DxContainer>
      </DxContainer>
    </div>
  );
};
